<script setup lang="ts">
import {ref} from "vue";
import CourseCreatorForm from "components/dialog/common/innner/CourseCreatorForm.vue";
import {AddCourse} from "@/types";
import {CourseService} from "@/api/api.ts";
import {useRouter} from "vue-router";
import {ElNotification} from "element-plus";

const router = useRouter()

const isShowing = ref(false)
const type = ref(1)

const show = (_type: number) => {
  type.value = _type
  isShowing.value = true
}

const hide = () => {
  isShowing.value = false
}

const onAddCourse = async (info: AddCourse) => {
  try {
    //@ts-ignore
    const res = await CourseService.addCourse(info)
    if (res.data.code === 200) {
      const routeData = router.resolve({
        name: "CourseDetail",
        params: {
          id: res.data.data
        }
      })
      window.open(routeData.href, "_blank")
      hide()
    } else {
      ElNotification.error({
        title: "创建课程失败",
        message: res.data.msg,
      })
    }
  } catch (error) {
    console.log(error)
  }
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog title="创建课程" v-model="isShowing" align-center :close-on-click-modal="false">
    <el-tabs v-model="type">
      <el-tab-pane :name="1" label="直播课">
        <course-creator-form @onAddCourse="onAddCourse" :type="1" />
      </el-tab-pane>
      <el-tab-pane :name="2"  label="录播课">
        <course-creator-form @onAddCourse="onAddCourse" :type="2" />
      </el-tab-pane>
      <el-tab-pane :name="3" label="系列课">
        <course-creator-form  @onAddCourse="onAddCourse" :type="3" />
      </el-tab-pane>
      <el-tab-pane :name="4"  label="组合课">
        <course-creator-form @onAddCourse="onAddCourse" :type="4" />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<style scoped>
</style>
